<div class="grid-table"
  [ngClass]="{'grid-facets': gridSettings.ResizeGridForFacetsControl && facetsCollapsed == false, 'grid-with-facets-collapsed' : facetsCollapsed == true}">
  <div class="table-container shadow" [class.wg-gallery-mode]="viewType === 'grid' || viewType === 'grid-large' || viewType === 'grid-oneline'">
    <!--<div class="dd-container">
      <div class="dd-grid">
        <p>Filter</p>
      </div>
      <div class="dd-grid">
        <p>Print results</p>
      </div>
    </div>-->

    <div class="wg-grid-super-header">
      <div class="wg-grid-super-left">
        <span class="wg-grid-count">{{totalItems | number}}</span>
        <span class="wg-grid-count-label">{{translate('WebGalis_Module_Module_Result_ResultPrimary')}}</span>
        <span *ngFor="let addField of additionalListingFields" class="wg-grid-count-label">{{addField}}</span>
      </div>
      <div class="wg-grid-super-right">
        <div class="central wg-add-new-btn" *ngIf="gridSettings.ShowNewForm" (click)="addNew()">
          <div class="icon centraled"></div>
        </div>
        <div class="number-of-pages-setting">
          <label>{{translate('galis_js_show')}}:</label>
          <div class="select-items">
            <select (change)="changeNumberOfPages($event)" [(ngModel)]="numberOfPagesValue">
              <option *ngFor="let num of uiPages" [value]="num">{{num}} / {{translate('galis_js_recordsperpage')}}</option>
            </select>
          </div>
        </div>
        <div class="wg-view-toggles" *ngIf="gridSettings?.HideDisplayFieldChangeButton == false && !isRestrictedByGroup('hideGridSettingsForGroups')">
          <div class="icon list"
            [ngStyle]="{'background-image': viewType == 'list' ? 'url(assets/css/images/platform/list-icon-color@3x.png)' : 'url(assets/css/images/platform/list-icon-gray@3x.png)' }"
            (click)="toggleViewType('list')"></div>
          <div class="icon cube"
            [ngStyle]="{'background-image': viewType == 'grid' ? 'url(assets/css/images/platform/grid-multiple@3x.png)' : 'url(assets/css/images/platform/grid-multiple-clear@3x.png)' }"
            (click)="toggleViewType('grid')"></div>
          <div class="icon one-cube"
            [ngStyle]="{'background-image': viewType == 'grid-large' ? 'url(assets/css/images/platform/grid-icon-color@3x.png)' : 'url(assets/css/images/platform/grid-icon-gray@3x.png)' }"
            (click)="toggleViewType('grid-large')"></div>
          <div class="icon one-cube"
            [ngStyle]="{'background-image': viewType == 'grid-oneline' ? 'url(assets/css/images/platform/full-cube@3x.png)' : 'url(assets/css/images/platform/full-cube-gray@3x.png)' }"
            (click)="toggleViewType('grid-oneline')"></div>
        </div>
        <div class="wg-settings-btn" *ngIf="gridSettings?.HideDisplayFieldChangeButton == false && !isRestrictedByGroup('hideGridSettingsForGroups')" (click)="openViewSettings()">
          <span class="material-symbols-outlined">settings</span>
        </div>
      </div>
    </div>

    <!--div class="listing-loader" *ngIf="loading">
      <img class="control-loader" src="/assets/css/images/platform/loader.gif" />
    </div-->
    <sem-loader [showLoader]="loading"></sem-loader>


    <!-- Gallery: 6 per row (compact cards) -->
    <div *ngIf="viewType == 'grid' && !loading" class="wg-gallery wg-gallery--small">
      <div class="wg-gallery-card" *ngFor="let gridItem of model.Models"
        (click)="itemClick(gridItem)" (dblclick)="itemClickNavigate(gridItem)" (contextmenu)="onContextMenu($event, gridItem)">
        <div class="wg-gallery-card__image">
          <ng-container *ngFor="let column of getByType(false)">
            <sem-image-viewer *ngIf="column.IsImageControl == true && resolvePropertyBinding(gridItem,column.BindingField)"
              [mediaId]="resolvePropertyBinding(gridItem,column.BindingField)"
              [height]="300" [width]="300"></sem-image-viewer>
          </ng-container>
          <div class="wg-gallery-card__placeholder" *ngIf="!hasImage(gridItem)">
            <span class="material-symbols-outlined">image</span>
          </div>
        </div>
        <div class="wg-gallery-card__body">
          <ng-container *ngFor="let column of getByType(false); let i = index">
            <div *ngIf="showDataGridColumn(column.IsImageControl, column.IsBoolean)"
              class="wg-gallery-card__field-row"
              [class.wg-gallery-card__field-row--primary]="i === 0"
              [class.wg-gallery-card__field-row--secondary]="i === 1"
              [class.wg-gallery-card__field-row--extra]="i > 1"
              [title]="resolvePropertyBinding(gridItem,column.BindingField)">
              <span class="wg-gallery-card__label" *ngIf="i > 0">{{getColumnHeader(column)}}</span>
              <span class="wg-gallery-card__value">{{resolvePropertyBinding(gridItem,column.BindingField)}}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Gallery: 3 per row (medium cards) -->
    <div *ngIf="viewType == 'grid-large' && !loading" class="wg-gallery wg-gallery--medium">
      <div class="wg-gallery-card" *ngFor="let gridItem of model.Models"
        (click)="itemClick(gridItem)" (dblclick)="itemClickNavigate(gridItem)" (contextmenu)="onContextMenu($event, gridItem)">
        <div class="wg-gallery-card__image">
          <ng-container *ngFor="let column of getByType(false)">
            <sem-image-viewer *ngIf="column.IsImageControl == true && resolvePropertyBinding(gridItem,column.BindingField)"
              [mediaId]="resolvePropertyBinding(gridItem,column.BindingField)"
              [height]="550" [width]="550"></sem-image-viewer>
          </ng-container>
          <div class="wg-gallery-card__placeholder" *ngIf="!hasImage(gridItem)">
            <span class="material-symbols-outlined">image</span>
          </div>
        </div>
        <div class="wg-gallery-card__body">
          <ng-container *ngFor="let column of getByType(false); let i = index">
            <div *ngIf="showDataGridColumn(column.IsImageControl, column.IsBoolean)"
              class="wg-gallery-card__field-row"
              [class.wg-gallery-card__field-row--primary]="i === 0"
              [class.wg-gallery-card__field-row--secondary]="i === 1"
              [class.wg-gallery-card__field-row--extra]="i > 1"
              [title]="resolvePropertyBinding(gridItem,column.BindingField)">
              <span class="wg-gallery-card__label">{{getColumnHeader(column)}}</span>
              <span class="wg-gallery-card__value">{{resolvePropertyBinding(gridItem,column.BindingField)}}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Gallery: 1 per row (showcase — big image + metadata in card) -->
    <div *ngIf="viewType == 'grid-oneline' && !loading" class="wg-gallery wg-gallery--showcase">
      <div class="wg-gallery-showcase" *ngFor="let gridItem of model.Models"
        (click)="itemClick(gridItem)" (dblclick)="itemClickNavigate(gridItem)" (contextmenu)="onContextMenu($event, gridItem)">
        <div class="wg-gallery-showcase__image">
          <ng-container *ngFor="let column of getByType(false)">
            <sem-image-viewer *ngIf="column.IsImageControl == true && resolvePropertyBinding(gridItem,column.BindingField)"
              [mediaId]="resolvePropertyBinding(gridItem,column.BindingField)"
              [height]="800" [width]="800"></sem-image-viewer>
          </ng-container>
          <div class="wg-gallery-card__placeholder" *ngIf="!hasImage(gridItem)">
            <span class="material-symbols-outlined">image</span>
          </div>
        </div>
        <div class="wg-gallery-showcase__meta">
          <ng-container *ngFor="let column of getByType(false); let i = index">
            <div *ngIf="showDataGridColumn(column.IsImageControl, column.IsBoolean)"
              class="wg-gallery-showcase__field-item"
              [class.wg-gallery-showcase__field-item--primary]="i === 0">
              <span class="wg-gallery-showcase__label">{{getColumnHeader(column)}}</span>
              <span class="wg-gallery-showcase__value"
                [class.wg-gallery-showcase__value--primary]="i === 0">
                {{resolvePropertyBinding(gridItem,column.BindingField)}}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>


    <div class="table-wrapper" *ngIf="viewType == 'list' && !loading">
        <table class="table table-hover" *ngIf="!loading" [style.width.px]="totalColumnWidth">
          <thead>
            <tr>
              <th *ngIf="bulkActionPresent == true" class="numbering thSmall"
                [ngClass]="{'checkbox-bulk-table-head': bulkActionPresent == true}">
                <div class="checkbox-bulk" (click)="checkboxBulkCheckAllItems()"
                  [ngClass]="{'checkbox-bulk-checked': checkboxAllItemsChecked == true}">
                  <input type="checkbox" name="checkboxAllItemsClicked" />
                  <span class="tooltip-text tooltip-text-checkbox">{{translate('galis_js_grid_oznaci_vse')}}</span>
                </div>
              </th>
              <th *ngIf="additionalSearchSettings.showItemNumber == true" class="numbering thSmall">

              </th>
              @for (column of getByType(false); track $index) {
              <th class="sem-data-grid-th"
                [style.width.px]="columnWidths[column.BindingField] || null">
                <p>{{column.HeaderText}}</p>

                <div class="sorting-container" *ngIf="helperColumnFlags[column.BindingField]?.IsSortable"
                  (click)="sortDropDownClick(column, $event)"
                  [ngClass]="{'sorting-container-used': helperColumnFlags[column.BindingField]?.SortingUsed}">
                  <span class="drop-down-sorting-icon">
                    <img src="/assets/css/images/platform/arrow-down-s.png" />
                  </span>

                  <div class="drop-down-sorting-container" *ngIf="helperColumnFlags[column.BindingField]?.ShowSort">
                    <div class="drop-down-sorting-item" (click)="setColumnSorting(column,0,$event)">
                      <p><img
                          src="/assets/css/images/platform/fill-10.png" />{{translate('galis_js_GridData_Ascending')}}
                      </p>
                    </div>
                    <div class="drop-down-sorting-item" (click)="setColumnSorting(column,1,$event)">
                      <p><img
                          src="/assets/css/images/platform/filld-10.png" />{{translate('galis_js_GridData_Descending')}}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="inuse-sorting-container" *ngIf="helperColumnFlags[column.BindingField]?.SortingUsed">
                  <img src="/assets/css/images/platform/fill-10.png"
                    *ngIf="helperColumnFlags[column.BindingField]?.SortDirection == 0">
                  <img src="/assets/css/images/platform/filld-10.png"
                    *ngIf="helperColumnFlags[column.BindingField]?.SortDirection == 1" />
                </div>
                <div class="wg-col-resize-handle" *ngIf="!isRestrictedByGroup('hideColumnResizeForGroups')" (mousedown)="onResizeStart($event, column.BindingField)"></div>
              </th>
            }
              <th *ngIf="additionalSearchSettings.showActionsColumn == true && !isRestrictedByGroup('hideActionsColumnForGroups')" class="wg-actions-col"></th>
              <th class="wg-column-chooser-th" #columnChooserContainer *ngIf="!isRestrictedByGroup('hideColumnChooserForGroups')">
                <button type="button" class="wg-column-chooser-btn" (click)="toggleColumnChooser($event)">
                  <span class="material-symbols-outlined">add</span>
                </button>
                @if (showColumnChooser) {
                  <div class="wg-quick-add-panel wg-column-chooser-panel" (click)="$event.stopPropagation()">
                    <div class="wg-quick-add-search-wrapper">
                      <div class="wg-quick-add-search">
                        <span class="material-symbols-outlined">search</span>
                        <input type="text" placeholder="Iskanje stolpcev..."
                          [(ngModel)]="columnChooserSearch"
                          (input)="filterColumnChooserFields()" />
                      </div>
                    </div>
                    <div class="wg-quick-add-list">
                      @for (field of filteredColumnChooserFields; track field.Name) {
                        <button type="button" class="wg-quick-add-item" [title]="field.Translation" (click)="toggleGridColumn(field)">
                          <div class="wg-quick-add-checkbox" [class.wg-quick-add-checked]="isGridColumnActive(field)">
                            @if (isGridColumnActive(field)) {
                              <span class="material-symbols-outlined">check</span>
                            }
                          </div>
                          <span>{{ field.Translation }}</span>
                        </button>
                      }
                      @if (filteredColumnChooserFields.length === 0) {
                        <div class="wg-quick-add-empty">Ni rezultatov</div>
                      }
                    </div>
                    <div class="wg-quick-add-footer">
                      <button type="button" class="wg-quick-add-footer-btn wg-quick-add-footer-close" (click)="showColumnChooser = false">Zapri</button>
                    </div>
                  </div>
                }
              </th>
            </tr>
            <tr class="wg-filter-row" *ngIf="!isRestrictedByGroup('hideInlineFiltersForGroups')">
              <th *ngIf="bulkActionPresent == true" class="wg-filter-cell-empty"></th>
              <th *ngIf="additionalSearchSettings.showItemNumber == true" class="wg-filter-cell-empty"></th>
              @for (column of getByType(false); track $index) {
                <th class="wg-filter-cell">
                  @if (!column.IsBoolean) {
                    <input type="text" class="wg-inline-filter-input" placeholder="Filtriraj..."
                      (input)="onColumnFilter(column.BindingField, $any($event.target).value)" />
                  }
                </th>
              }
              <th *ngIf="additionalSearchSettings.showActionsColumn == true && !isRestrictedByGroup('hideActionsColumnForGroups')" class="wg-filter-cell-empty wg-actions-filter-cell"></th>
              <th class="wg-filter-cell-empty wg-column-chooser-filter-cell" *ngIf="!isRestrictedByGroup('hideColumnChooserForGroups')"></th>
            </tr>
          </thead>
          <tbody>
            @for (dataItem of model[bindingPropertyName]; track $index; let i = $index ) {
            <tr
              [ngClass]="getGridRowClassList(dataItem)">
              <td *ngIf="bulkActionPresent == true" stop-click-propagation class="bulk-checkbox numbering">
                <div class="checkbox-bulk" stop-click-propagation (click)="checkboxBulkItemClicked(dataItem)"
                  [ngClass]="{'checkbox-bulk-checked': checkedBulkItemStatus[resolvePropertyBinding(dataItem,'Id')] == true}">
                  <input type="checkbox" name="resolvePropertyBinding(dataItem,Id)" />
                </div>
              </td>
              <td *ngIf="additionalSearchSettings.showItemNumber == true" class="numbering">
                <p>{{calculateItemNumber(i)}}</p>
              </td>
              @for (column of getByType(false); track $index; let i = $index ) {
              <td (click)="itemClick(dataItem)"
                (dblclick)="itemClickNavigate(dataItem)" (contextmenu)="onContextMenu($event, dataItem)">
                <!--<input [(ngModel)]="dataItem[column.BindingField]" />-->

                <!-- IF DATA IS IMAGE -->
                <div *ngIf="column.IsImageControl == true">
                  <sem-image-viewer [mediaId]="resolvePropertyBinding(dataItem,column.BindingField)"></sem-image-viewer>
                </div>

                <!-- IF DATA IS BOOLEAN TYPE -->
                <div *ngIf="column.IsBoolean == true">
                  <div *ngIf="resolvePropertyBinding(dataItem,column.BindingField) == true" class="boolean-grid-data">
                    <span class="true-circle boolean-circle"></span>
                    {{translate('galis_js_GridData_BooleanTrue')}}
                  </div>
                  <div *ngIf="resolvePropertyBinding(dataItem,column.BindingField) == false" class="boolean-grid-data">
                    <span class="false-circle boolean-circle"></span>
                    {{translate('galis_js_GridData_BooleanFalse')}}
                  </div>
                </div>


                <!-- IF DATA IS NORMAL STRING VALUE -->
                <div *ngIf="showDataGridColumn(column.IsImageControl, column.IsBoolean)">

                  <!-- A document library's file cell is the file: icon plus name, one click to open it. -->
                  <p class="wg-doclib-file" stop-click-propagation
                     *ngIf="editable === 'False' && isDocLibraryFile(dataItem, column.BindingField)"
                     (click)="openPrimaryFile($event, dataItem)"
                     [title]="resolvePropertyBinding(dataItem,column.BindingField)">
                    <span class="wg-doclib-file-icon" [ngClass]="fileIconClass(resolvePropertyBinding(dataItem,column.BindingField))"></span>
                    <span class="wg-doclib-file-name">{{resolvePropertyBinding(dataItem,column.BindingField)}}</span>
                  </p>

                  <p class="{{getClass(column.BindingField, dataItem)}}" *ngIf="editable === 'False' && showIfNotDate(column.IsDateTime) && !isDocLibraryFile(dataItem, column.BindingField)">
                    <span
                      *ngIf="isLink(dataItem, column.BindingField) == false">{{resolvePropertyBinding(dataItem,column.BindingField)}}</span>
                    <span class="link-data-grid-value" (click)="linkClick($event,dataItem, column.BindingField)"
                      *ngIf="isLink(dataItem, column.BindingField) == true">{{resolvePropertyBinding(dataItem,column.BindingField)}}</span>
                  </p>
                  <p *ngIf="editable === 'False' && column.IsDateTime">
                      <!-- Adjust the date by +02:00 hours and format it -->
                      {{ getFormattedDate(resolvePropertyBinding(dataItem, column.BindingField), 0) }}
                  </p>

                  <!--<input type="text" [(ng-model)]="column.bindingField" />-->

                  <div *ngIf="editable === 'True'">
                    <div [ngSwitch]="column.EditType">

                      <div class="input-holder">
                        <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" *ngSwitchCase="'Text'"
                          [(ngModel)]="dataItem[column.BindingField]"></sem-text-box>

                        <sem-drop-down-select [galregistryname]="column.ModelName" *ngSwitchCase="'DD'"
                          [(ngModel)]="dataItem[column.BindingField]"></sem-drop-down-select>
                      </div>

                    </div>
                  </div>
                </div>

              </td>
            }
              <td *ngIf="additionalSearchSettings.showActionsColumn == true && !isRestrictedByGroup('hideActionsColumnForGroups')" class="wg-actions-td">

                <!--<a *ngIf="params.url" class="btn btn-default btn-sm" (click)="itemClick(dataItem)"><span
                class="ti-icon ti-edit"></span></a>-->
                <a class="btn btn-default btn-sm" (click)="itemEditClick(dataItem)">
                  <span class="ti-icon ti-edit">
                    <span class="tooltip-text actions-tooltip-text">{{translate('galis_js_grid_actions_edit')}}</span>
                  </span>
                </a>

                <a class="btn btn-default btn-sm" target="_blank" [href]="itemDetailsHref(dataItem)">
                  <span class="ti-icon ti-redirect">
                    <span class="tooltip-text actions-tooltip-text">{{translate('galis_js_grid_actions_edit')}}</span>
                  </span>
                </a>
                <!--a *ngIf="gridSettings.InlineDelete" class="btn btn-default btn-sm" (click)="deleteItem(dataItem)"><span class="ti-icon ti-trash"></span></a

            <a *ngFor="let column of getByType(true)">
              <span (click)="performAction(column,dataItem)" class="ti-icon ti-printer"></span>
            </a>-->

                <!--span *ngIf="checkForm('Eurodesign.MoJ.PPMSCIS.Application.Model.Module.Penitentiary.CourtJudgementInformationModel')" (click)="performCJIAction(dataItem)" class="ti-icon ti-printer"></span>
            <span *ngIf="checkForm('Eurodesign.MoJ.PDCIS.Application.Model.MAK.MAKModel')" (click)="performMAKAction(dataItem)" class="ti-icon ti-printer"></span-->

                <span *ngFor="let formAction of getGridFormActions(2)">
                  <span (click)="performAction(formAction.FormAction,dataItem)"
                    class="grid-form-action {{formAction.CssClasses}}">
                    <span *ngIf="formAction.TooltipText != null"
                      class="tooltip-text grid-form-action-tooltip-text">{{translate(formAction.TooltipText)}}</span>
                  </span>
                </span>

              </td>
              <td class="wg-column-chooser-td" *ngIf="!isRestrictedByGroup('hideColumnChooserForGroups')"></td>
              <span *ngIf="additionalSearchSettings.quickViewEnabled" (click)="itemClick(dataItem)"
                class="tooltip-text data-grid-row-tooltip-text">{{translate('galis_js_grid_row_hover_tooltip_text')}}</span>
            </tr>
          }
          </tbody>
        </table>
    </div>
    <!--<div *ngIf="!itemsLoaded">
      <p>No items</p>
    </div>-->

    <div class="table-footer pagination">
      <div class="wg-pagination-info">
        <span class="wg-pagination-info-text">
          Prikazujem
          <span class="wg-pagination-info-bold">{{rangeStart | number}}–{{rangeEnd | number}}</span>
          od
          <span class="wg-pagination-info-bold">{{totalItems | number}}</span>
        </span>
      </div>
      <div class="pagination-container">
        <div class="left-double" *ngIf="previousPage > 0" (click)="toFirstPage()"></div>
        <div class="left" *ngIf="previousPage > 0" (click)="pageChanged(previousPage)"></div>
        <p *ngFor="let page of pages" [ngClass]="{'active': page.Active == true}" (click)="pageChanged(page.Number)">
          {{page.Number}}</p>
        <div class="right" *ngIf="nextPage > 0" (click)="pageChanged(nextPage)"></div>
        <div class="right-double" *ngIf="nextPage > 0" (click)="toLastPage()"></div>
      </div>
    </div>

    <div class="grid-action-container">
      <span *ngFor="let formAction of getGridFormActions(3)" (click)="performAction(formAction.FormAction,dataItem)"
        class="{{formAction.CssClasses}}" [matTooltip]="formAction.FormAction.Target">
        <span class="grid-inline-span">{{formAction.FormAction.Title}}</span>
      </span>
    </div>

  </div>
</div>

<!-- Context Menu -->
<div class="wg-context-menu" *ngIf="contextMenuVisible && contextMenuItem"
  [style.left.px]="contextMenuX" [style.top.px]="contextMenuY"
  (click)="$event.stopPropagation()" (contextmenu)="$event.preventDefault(); $event.stopPropagation()">

  <button type="button" class="wg-context-menu__item" (click)="contextMenuOpen(contextMenuItem)">
    <span class="material-symbols-outlined">open_in_browser</span>
    <span>{{tr('galis_js_grid_ctx_open', 'Open')}}</span>
  </button>
  <button type="button" class="wg-context-menu__item" (click)="contextMenuOpenNewTab(contextMenuItem)">
    <span class="material-symbols-outlined">open_in_new</span>
    <span>{{tr('galis_js_grid_ctx_open_new_tab', 'Open in new tab')}}</span>
  </button>
  <div class="wg-context-menu__submenu-wrapper"
    (mouseenter)="onPreviewHover()" (mouseleave)="contextMenuPreviewOpen = false">
    <button type="button" class="wg-context-menu__item wg-context-menu__item--has-sub">
      <span class="material-symbols-outlined">visibility</span>
      <span>{{tr('QuickPreview', 'Quick preview')}}</span>
      <span class="material-symbols-outlined wg-context-menu__chevron">chevron_right</span>
    </button>
    <div class="wg-context-menu__submenu wg-context-menu__preview" *ngIf="contextMenuPreviewOpen"
      (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
      <div class="wg-preview__header">
        <span class="wg-preview__title">{{tr('QuickPreview', 'Quick preview')}}</span>
        <div class="wg-preview__header-actions">
          <sem-loader [showLoader]="previewLoading" *ngIf="previewLoading"></sem-loader>
          <button type="button" class="wg-preview__open-btn" *ngIf="hasQuickViewForm" (click)="contextMenuPreview(contextMenuItem)">
            <span class="material-symbols-outlined">open_in_new</span>
            <span>{{tr('galis_js_grid_ctx_open_full', 'Open in full')}}</span>
          </button>
        </div>
      </div>
      <div class="wg-preview__content">
        <div class="wg-preview__grid" *ngIf="contextMenuPreviewData.length > 0">
          <div class="wg-preview__item" *ngFor="let prop of contextMenuPreviewData">
            <span class="wg-preview__label">{{prop.label}}</span>
            <span class="wg-preview__value" [title]="prop.value">{{prop.value}}</span>
          </div>
        </div>
        <div class="wg-preview__empty" *ngIf="contextMenuPreviewData.length === 0 && !previewLoading">
          <span class="material-symbols-outlined">info</span>
          <span>{{tr('galis_js_grid_ctx_no_properties', 'No properties found')}}</span>
        </div>
        <div class="wg-preview__add-section" *ngIf="previewEmptyFields.length > 0">
          <div class="wg-preview__add-inline" *ngIf="previewAddingField">
            <span class="wg-preview__add-label">{{previewEmptyFields.length > 0 ? (previewEmptyFields | slice:0:1)[0]?.label : previewAddingField}}</span>
            <input class="wg-preview__add-input" type="text"
              [(ngModel)]="previewAddingValue"
              [placeholder]="tr('galis_js_grid_ctx_enter_value', 'Enter value...')"
              (keydown.enter)="onPreviewSaveField()"
              (keydown.escape)="onPreviewCancelAdd()" />
            <div class="wg-preview__add-actions">
              <button type="button" class="wg-preview__add-save" (click)="onPreviewSaveField()">
                <span class="material-symbols-outlined">check</span>
              </button>
              <button type="button" class="wg-preview__add-cancel" (click)="onPreviewCancelAdd()">
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
          </div>
          <div class="wg-preview__add-picker" *ngIf="!previewAddingField">
            <button type="button" class="wg-preview__add-btn" (click)="showFieldPicker = !showFieldPicker">
              <span class="material-symbols-outlined">add_circle</span>
              <span>{{tr('galis_js_grid_ctx_add_property', 'Add property')}}</span>
            </button>
            <div class="wg-preview__field-list" *ngIf="showFieldPicker">
              <input class="wg-preview__field-search" type="text" [placeholder]="tr('galis_js_grid_ctx_search_fields', 'Search fields...')"
                [(ngModel)]="fieldPickerSearch" />
              <div class="wg-preview__field-options">
                <button type="button" class="wg-preview__field-option" *ngFor="let field of previewEmptyFields | slice:0:20"
                  (click)="onPreviewAddField(field); showFieldPicker = false">
                  {{field.label}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="wg-context-menu__separator"></div>

  <div class="wg-context-menu__submenu-wrapper"
    [class.wg-context-menu__submenu-wrapper--disabled]="getContextMenuActions().length === 0"
    (mouseenter)="getContextMenuActions().length > 0 && (contextMenuActionsOpen = true)"
    (mouseleave)="contextMenuActionsOpen = false">
    <button type="button" class="wg-context-menu__item wg-context-menu__item--has-sub"
      [class.wg-context-menu__item--disabled]="getContextMenuActions().length === 0">
      <span class="material-symbols-outlined">bolt</span>
      <span>{{tr('galis_js_grid_ctx_actions', 'Actions')}}</span>
      <span class="material-symbols-outlined wg-context-menu__chevron">chevron_right</span>
    </button>
    <div class="wg-context-menu__submenu" *ngIf="contextMenuActionsOpen && getContextMenuActions().length > 0">
      <button type="button" class="wg-context-menu__item" *ngFor="let action of getContextMenuActions()"
        (click)="contextMenuAction(action, contextMenuItem)">
        <span class="material-symbols-outlined">play_circle</span>
        <span>{{action.FormAction?.Title || tr('galis_js_grid_ctx_action', 'Action')}}</span>
      </button>
    </div>
  </div>

  <div class="wg-context-menu__submenu-wrapper"
    [class.wg-context-menu__submenu-wrapper--disabled]="getContextMenuWorkflows().length === 0"
    (mouseenter)="getContextMenuWorkflows().length > 0 && (contextMenuWorkflowsOpen = true)"
    (mouseleave)="contextMenuWorkflowsOpen = false">
    <button type="button" class="wg-context-menu__item wg-context-menu__item--has-sub"
      [class.wg-context-menu__item--disabled]="getContextMenuWorkflows().length === 0">
      <span class="material-symbols-outlined">account_tree</span>
      <span>{{tr('galis_js_grid_ctx_workflows', 'Workflows')}}</span>
      <span class="material-symbols-outlined wg-context-menu__chevron">chevron_right</span>
    </button>
    <div class="wg-context-menu__submenu" *ngIf="contextMenuWorkflowsOpen && getContextMenuWorkflows().length > 0">
      <button type="button" class="wg-context-menu__item" *ngFor="let wf of getContextMenuWorkflows()"
        (click)="contextMenuAction(wf, contextMenuItem)">
        <span class="material-symbols-outlined">play_circle</span>
        <span>{{wf.FormAction?.Title || tr('galis_js_grid_ctx_workflow', 'Workflow')}}</span>
      </button>
    </div>
  </div>

  <div class="wg-context-menu__separator"></div>

  <button type="button" class="wg-context-menu__item" (click)="contextMenuCopyId(contextMenuItem)">
    <span class="material-symbols-outlined">content_copy</span>
    <span>{{tr('galis_js_grid_ctx_copy_id', 'Copy ID')}}</span>
  </button>
  <button type="button" class="wg-context-menu__item" (click)="contextMenuCopyLink(contextMenuItem)">
    <span class="material-symbols-outlined">link</span>
    <span>{{tr('galis_js_grid_ctx_copy_link', 'Copy link')}}</span>
  </button>

</div>

<div class="quick-preview-container" *ngIf="searchService.currentPreviewItemClicked != null">
  <div class="quick-preview-header">
    <div class="quick-preview-header-title">
      <label>{{translate('QuickPreview')}}</label>
    </div>
    <div class="quick-preview-header-controls">
      <img src="/assets/css/images/platform/zoom-in@3x.png" class="zoom-in-icon" (click)="redirectPreviewToDetails()" />
      <span class="tooltip-text quickpreview-tooltip-text-redirect">{{translate('galis_js_grid_podrobnosti')}}</span>
      <span class="quick-preview-header-controls-separator"></span>
      <img src="/assets/css/images/platform/icon-close@3x.png" class="close-icon" (click)="previewClose()" />
      <span class="tooltip-text quickpreview-tooltip-text-close">{{translate('galis_js_grid_close')}}</span>
    </div>
  </div>
  <div class="quick-preview-content">
    <ng-scrollbar [visibility]="'hover'">
      <app-sem-dynamic-control #dynComp (modelChanged)="modelChanged($event)"
        [url]="additionalSearchSettings.quickViewFormName" [entityId]="searchService.currentPreviewItemClicked.Id">
      </app-sem-dynamic-control>
    </ng-scrollbar>
  </div>
  <div class="quick-preview-footer" *ngIf="previewActions.length > 0">
    <div class="quick-preview-footer-left">
      <button type="button" (click)="actionDD($event)" class="accept">{{translate('Save')}}</button>

      <div class="dd" *ngIf="previewActions.length > 1 && ddShown">

        <p *ngFor="let action of previewActions" (click)="runAction(action)">
          {{action.Title}}</p>

      </div>
    </div>
    <div class="quick-preview-footer-right">
      <button type="button" class="decline" (click)="previewClose()">{{translate('Cancel')}}</button>
    </div>
  </div>
</div>